<template>
  <div class="page-content">
    <div class="container-fluid">
      <div class="page-content__header-description">Audit Trail</div>
      <div class="row">

        <div class="col-xl-4 col-lg-4 col-md-4">
          <div class="widget widget-alpha dash-widget">
            <!-- <div class="dash-widget-header">Audit Trail</div> -->
            <div class="dash-widget-body">
              <div class="widget-icon">
                <i class="fa fa-list fa-3x widget-alpha__icon"></i>
              </div>
              <!-- <div class="widget-alpha__amount">Feedback</div>
              <div class="widget-alpha__description">...</div> -->
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/auditTrail.vue